"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQrCodeImage = void 0;
const react_1 = require("react");
const qrCodeHelpers_1 = require("./qrCodeHelpers");
const useQrCodeImage = ({ value, label, description }) => {
    const [imageUrl, setImageUrl] = (0, react_1.useState)("");
    const [width, setWidth] = (0, react_1.useState)(0);
    const [height, setHeight] = (0, react_1.useState)(0);
    const generateQrCode = async () => {
        const { imageUrl, width, height } = await (0, qrCodeHelpers_1.getQrCodeImage)({ value, label, description });
        setImageUrl(imageUrl);
        setWidth(width);
        setHeight(height);
    };
    (0, react_1.useEffect)(() => {
        (async () => generateQrCode())();
    }, []);
    return {
        imageUrl,
        width,
        height
    };
};
exports.useQrCodeImage = useQrCodeImage;
